import React, { Fragment, useEffect, useRef, useState } from 'react';
import {
  Box, CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, tableCellClasses, ListItemText,
  InputLabel,
  FormControl,
  Checkbox,
  Select,
  MenuItem,
  Tooltip,
  InputAdornment
} from '@mui/material';
import styled from '@emotion/styled';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { CheckIcon, FontFamily, PendingIcon, SearchIcon } from 'assets';
import Colors from 'assets/Style/Colors';
import { ErrorToaster } from 'components/Toaster';
import { CircleLoading } from 'components/Loaders';
import Pagination from 'components/Pagination';
import InputField from 'components/Input';
import { useForm } from 'react-hook-form';
import moment from 'moment';
// import { handleExportWithComponent } from 'utils';
import VccServices from 'services/Vcc';
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { PDFExport } from '@progress/kendo-react-pdf';

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    background: Colors.primary,
    color: Colors.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: 'center',
    textWrap: 'nowrap',
    padding: '5px !important',

    '.MuiBox-root': {
      display: 'flex',
      gap: '6px',
      alignItems: 'center',
      justifyContent: 'center',
      '.MuiBox-root': {
        cursor: 'pointer'
      }
    },
    'svg': {
      width: 'auto',
      height: '24px'
    },
    '.MuiTypography-root': {
      textTransform: 'capitalize',
      fontFamily: FontFamily.NunitoRegular,
      textWrap: 'nowrap',
    },
    '.MuiButtonBase-root': {
      padding: '8px',
      width: '28px',
      height: '28px',
    }
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: 'flex',
    height: 100,
    '& svg': {
      width: '40px !important',
      height: '40px !important'
    }
  }
})

function VccDownloadedList() {

  const navigate = useNavigate();
  const classes = useStyles();
  const contentRef = useRef(null);

  const tableHead = ['Customer ID', 'Customer Name', 'VIN', 'VCC Declaration Number', 'Downloaded Date', 'Vcc Downloaded', 'Declaration Downloaded']

  const [visibleColumns, setVisibleColumns] = useState([...Array(tableHead?.length).keys()]);

  const { register } = useForm();

  const [loader, setLoader] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  // *For VCC Refunded List
  const [vccDepositedList, setVccDepositedList] = useState();

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  // *For Filters
  const [filters, setFilters] = useState({});

  // *For Tooltip
  const [copied, setCopied] = useState(false);

  const copyContent = (text) => {
    const contentToCopy = text;
    navigator.clipboard.writeText(contentToCopy);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 300);
  }

  // *For Get VCC Refunded List
  const getVccDownloadedList = async (page, limit, filter) => {
    setLoader(true);
    try {
      const Page = page ? page : currentPage
      const Limit = limit ? limit : pageLimit
      const Filter = { ...filters, ...filter }
      setCurrentPage(Page)
      setPageLimit(Limit)
      setFilters(Filter)
      let params = {
        page: Page,
        limit: Limit
      }
      params = { ...params, ...Filter }
      const { data } = await VccServices.getVccDownloadedList(params)
      setVccDepositedList(data?.vehicles?.rows)
      setTotalCount(data?.vehicles?.count)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false);
    }
  }

  // *For Handle Filter
  const handleFilter = async (data) => {
    setLoader(true);
        if (isSearching) return;
    
        setIsSearching(true);
        try {
          await getVccDownloadedList(1, '', data);
        } catch (err) {
          console.error("Search failed:", err);
        } finally {
          setIsSearching(false);
          setLoader(false);
        }
  }
  const handleColumnChange = (event) => {
    const selectedColumns = event.target.value;
    // Sort the selected columns to maintain the correct order
    const sortedColumns = selectedColumns.sort((a, b) => a - b);
    setVisibleColumns(sortedColumns);
  };

  const renderCellContent = (colIndex, item, isActive,) => {

    switch (colIndex) {
      case 0:
        return item?.booking?.customer?.id ?? '-';
      case 1:
        return (
          <Tooltip
            title={item?.booking?.customer?.name ?? "-"}
            arrow
            placement="top"
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [10, -2],
                    },
                  },
                ],
              },
            }}
          >
            <span>{
               item?.booking?.customer?.name
            }</span>
          </Tooltip>
        )
      // item?.booking?.customer?.name ?? '-';
      case 2:
        return (
          <Tooltip
            title={copied ? "copied" : item?.booking?.vin ?? "-"}
            arrow
            placement="top"
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [10, -2],
                    },
                  },
                ],
              },
            }}
            onClick={() => copyContent(item?.booking?.vin ?? "-")}
          >
            <span>{
               item?.booking?.vin
            }</span>
          </Tooltip>
        )




      case 3:
        return (
          <Tooltip
            title={item?.vcc?.vcc_declaration ?? "-"}
            arrow
            placement="top"
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [10, -2],
                    },
                  },
                ],
              },
            }}
          >
            <span>{
              item?.vcc?.vcc_declaration?.length > 12
                ? item?.vcc?.vcc_declaration?.slice(0, 8) + "..." : item?.vcc?.vcc_declaration
            }</span>
          </Tooltip>
        )

      case 4:
        return item?.download ? moment(item?.download?.created_at).format('DD-MM-YYYY') : '-';
      case 5:
        return item?.download?.vcc_downloaded ? <Box> <span className='pdf-hide'><CheckIcon /> </span> Downloaded  </Box> : <Box> <span className='pdf-hide'> <PendingIcon /> </span> Not Downloaded  </Box>;
      case 6:
        return item?.download?.declaration_downloaded ? <Box> <span className='pdf-hide'><CheckIcon /> </span> Downloaded  </Box> : <Box> <span className='pdf-hide'><PendingIcon /> </span> Not Downloaded  </Box>;
      default:
        return "-";
    }
  };

  // const downloadExcel = () => {
  //   const headers = tableHead.filter((item) => item !== "Action");
  //   const rows = vccDepositedList?.map((item) => [
  //     item?.booking?.customer?.id ?? '-',
  //     item?.booking?.customer?.name ?? "-",
  //     item?.booking?.vin ?? "-",
  //     item?.vcc?.vcc_declaration ?? "-",
  //     item?.download ? moment(item?.download?.created_at).format('DD-MM-YYYY') : '-',
  //     item?.download?.vcc_downloaded ? "Downloaded" : "Not Downloaded",
  //     item?.download?.declaration_downloaded ? "Downloaded" : "Not Downloaded"
  //   ])

  //   const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  //   const buf = XLSX.write(wb, {
  //     bookType: "xlsx",
  //     type: "array",
  //     mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(new Blob([buf]), "data.xlsx");
  // };

  useEffect(() => {
    getVccDownloadedList()
  }, []);

  return (
    <Box sx={{ m: 4, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mr: 4,
          my: 4,
        }}
      >
        <Typography variant="h5" sx={{ color: Colors.charcoalGrey, fontFamily: FontFamily.NunitoRegular, }}>
          VCC Downloaded List
        </Typography>
        {/* {vccDepositedList?.length > 0 && (
          <Box sx={{
            textAlign: "right", p: 4, display: "flex", gap: 2

          }}>
            <PrimaryButton
              title="Download PDF"
              type="button"
              style={{ backgroundColor: Colors.bluishCyan }}
              onClick={() => handleExportWithComponent(contentRef)}
            />
            <PrimaryButton
              title={"Download Excel"}
              onClick={() => downloadExcel()}
            />
          </Box>
        )} */}
      </Box>

      {/* Filters */}
      <Box sx={{ boxShadow: " 0px 3px 10px 0px #00000040", p: 3, borderRadius: '15px' }}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12} sm={3}>
            <InputField
              size={'small'}
              inputStyle={{ backgroundColor: '#f5f5f5' }}
              label={'Search'}
              InputProps={{
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
              }}
              placeholder={'Search'}
              register={register('search', {
                onChange: (e) => handleFilter({ search: e.target.value })
              })}
            />
          </Grid>
          {/* <Grid item xs={12} sm={3}>
          <InputField
            size={'small'}
            label={'Container'}
            placeholder={'Container'}
            register={register('container', {
              onChange: (e) => handleFilter({ container: e.target.value })
            })}
          />
        </Grid> */}

        </Grid>


        <Grid item md={11}>
          {vccDepositedList && <Box>

            <Grid container mb={2} >
              <Grid item xs={5}>
                <FormControl>
                  <InputLabel>Columns</InputLabel>
                  <Select
                    size={'small'}
                    multiple
                    value={visibleColumns}
                    label={'Columns'}
                    onChange={handleColumnChange}
                    renderValue={() => "Show/Hide"}
                  >

                    {tableHead.map((column, index) => {


                      if (column !== 'Action' && column !== 'Status') {
                        return (
                          <MenuItem key={index} value={index}>
                            <Checkbox checked={visibleColumns.includes(index)} />
                            <ListItemText primary={column} />
                          </MenuItem>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {(
              vccDepositedList && (
                <Fragment>
                  {/* <PDFExport ref={contentRef} landscape={true} paperSize="A4" margin={5}
                    fileName='VCC Downloaded List'
                  > */}
                    <Box className='pdf-show' sx={{ display: 'none' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="h5" sx={{ color: Colors.charcoalGrey, fontFamily: FontFamily.NunitoRegular, mb: 2 }}>
                          VCC Downloaded List
                        </Typography>
                        <Box sx={{ fontWeight: 400, fontSize: "12px", mt: 1.5, color: Colors.charcoalGrey, }}><span>Date: &nbsp;&nbsp;</span>{moment().format('MM-DD-YYYY')}</Box>
                      </Box>
                    </Box>
                    <TableContainer
                      component={Paper}
                      sx={{ boxShadow: '0px 8px 18px 0px #9B9B9B1A', borderRadius: 2, maxHeight: 'calc(100vh - 330px)' }}
                      className='table-box'
                    >
                      <Table stickyHeader sx={{ minWidth: 500 }}>
                        {/* Table Header */}
                        <TableHead>
                          <TableRow>
                            {visibleColumns.map((index) => (
                              <Cell className='pdf-table'
                                key={index}

                              >
                                {tableHead[index]}
                              </Cell>
                            ))}
                          </TableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody>
                          {!loader ? (
                            vccDepositedList?.length > 0 ? (
                              <Fragment>
                                {vccDepositedList?.map((item, rowIndex) => {

                                  const isActive = true;
                                  return (
                                    <Row
                                      key={rowIndex}
                                      sx={{ bgcolor: rowIndex % 2 !== 0 && "#EFF8E7" }}
                                    >
                                      {visibleColumns.map((colIndex) => (
                                        <Cell className='pdf-table' key={colIndex}>
                                          {renderCellContent(colIndex, item, isActive,)}
                                        </Cell>
                                      ))}
                                    </Row>

                                  );
                                })}

                              </Fragment>
                            ) : (
                              <Row>
                                <Cell
                                  colSpan={tableHead.length + 1}
                                  align="center"
                                  sx={{ fontWeight: 600 }}
                                >
                                  No Data Found
                                </Cell>
                              </Row>
                            )
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={visibleColumns?.length + 2}
                                align="center"
                                sx={{ fontWeight: 600 }}
                              >
                                <Box className={classes.loaderWrap}>
                                  <CircularProgress />
                                </Box>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  {/* </PDFExport> */}
                  {/* ========== Pagination ========== */}
                  <Pagination
                    currentPage={currentPage}
                    pageSize={pageLimit}
                    onPageSizeChange={(size) => getVccDownloadedList(1, size.target.value)}
                    tableCount={vccDepositedList?.length}
                    totalCount={totalCount}
                    onPageChange={(page) => getVccDownloadedList(page, "")}
                  />

                </Fragment>
              )
            )}


            {loader && <CircleLoading />}

          </Box>}





        </Grid>
      </Box>
    </Box >
  );
}

export default VccDownloadedList;